// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"54":"component---src-layouts-pages-page-header-footer-tsx","197":"75fc9c18"}[chunkId] || chunkId) + "-" + {"54":"2aead639ef4dd22d8dbf","197":"9a0697775b805789924f","522":"253dd55bc62b8c98eeeb"}[chunkId] + ".js";
};